module.exports = __webpack_public_path__ + "static/media/Kukur.45cca378.ogg";